import { pushTrackerEvent } from '../../_googleTagManager';

export default function cookiesDatalayerTracking() {
  let dataSession = document.querySelectorAll('[data-session]');

  function deleteSessionCookie(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  if (dataSession) {
    for(let item of dataSession) {

      let getSession = item.getAttribute('data-session');

      switch (getSession) {
        case 'multi_step_form_data':
          const cookies = document.cookie.split(";");
          for (let cookie of cookies) {
            let [name, value] = cookie.trim().split("=");
            if (name === "multi_step_form_data") {
              let getLocation = function (href) {
                let l = document.createElement('a');
                l.href = href;
                return l;
              };

              let l = getLocation(window.location.href);

              let formData = JSON.parse(cookie.trim().replace('multi_step_form_data=',''))
              let event_path = l.pathname + l.hash;
              let event_url = window.location.href;

              formData['event_path'] = event_path;
              formData['event_url'] = event_url;

              function checkGTMAndTrack() {
                const gtmScript = document.querySelector('script[src*="googletagmanager.com"]');

                if (gtmScript) {
                  clearInterval(interval);

                  setTimeout(function (){
                    pushTrackerEvent('contactform.multilevel', formData);

                    deleteSessionCookie("multi_step_form_data");
                  },1000)
                } else {
                  // Das Google Tag Manager Script ist noch nicht vorhanden
                  console.debug('Google Tag Manager Script nicht gefunden.');
                }
              }

              const interval = setInterval(checkGTMAndTrack, 1000);
            }
          }
          break;
      }
    }
  }
}

